import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../utils/firebase.jsx";
import ProposalListing from "../../components/ProposalListing.jsx";
import { useParams, Link } from "react-router-dom";
import {
  getCommunityMemberEmailList,
  getCurrentUser,
} from "../../utils/firebaseOperations.jsx";
import { UserContext } from "../../functions/UserContext.jsx";

export default function communityTemplate() {
  // Get community from url params
  const { community } = useParams();
  const { user, uid } = React.useContext(UserContext);

  // State for user level
  const [userLevel, setUserLevel] = useState(null);

  // Query for proposals
  let propRef;
  // Query for community
  let comRef;

  // check if community is defined in url params and set query accordingly
  if (community) {
    // if community is defined, query for proposals in that community
    propRef = query(
      // query for proposals where slug == community
      collection(db, "Proposals"),
      where("slug", "==", community)
    );

    // query for community where slug == community
    comRef = query(
      // query for community where slug == community
      collection(db, "Communities"),
      where("slug", "==", community)
    );
  }

  // State for proposals and community
  const [proposals, setProposals] = useState([]);
  // State for community
  const [com, setCom] = useState({});

  // State for query
  const [queryState, setQueryState] = useState({
    isLoading: true,
    errorMessage: "",
    docSnapshots: null,
  });

  // useEffect to get proposals and community
  useEffect(() => {
    // async function to load data
    function loader() {
      try {
        // set query state to loading
        setQueryState({
          isLoading: true,
          errorMessage: "",
          docSnapshots: null,
        });
        // get proposals from server
        setQueryState({
          isLoading: false,
          errorMessage: "",
          docSnapshots: proposals,
        });
      } catch (error) {
        // set query state to error
        setQueryState({
          isLoading: false,
          errorMessage: "Error",
          docSnapshots: null,
        });
        console.log(error);
      }
    }

    // call loader function to load data from server
    loader();

    // async function to get proposals from server
    const getProposals = async () => {
      // get proposals from server
      const proposalsFromServer = await getDocs(propRef);

      // set proposals state
      let proposals = [];
      // loop through proposals from server and push to proposals state
      proposalsFromServer.forEach((doc) => {
        // check if proposal is active
        if (doc.data().status == "active") {
          // push proposal to proposals state
          proposals.push({ ...doc.data(), id: doc.id });
          setProposals(proposals);
        }
      });
    };
    // call getProposals function to get proposals from server
    getProposals();

    const getCommunity = async () => {
      const comFromServer = await getDocs(comRef);
      if (comFromServer.docs[0]) {
        setCom(comFromServer.docs[0].data());
      } else {
        console.log("No matching community found");
      }
    };

    getCommunity();

    getCurrentUser().then((user) => {
      if (user) {
        setUserLevel(user.data().userTypeNumber);
      } else {
        console.log("No user found");
      }
    });
  }, []);

  const { isLoading, errorMessage } = queryState;

  let content;

  if (isLoading) {
    content = (
      <div
        className="spinner-border text-primary text-center justify-center mx-auto flex"
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  } else if (errorMessage) {
    content = errorMessage;
  } else {
    content = (
      <div className="container">
        <div
          className="proposalHero"
          style={{
            backgroundImage: `url(${com.img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "350px",
            width: "100%",
            marginBottom: "1em",
            borderRadius: "5px",
            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.5)",
            position: "relative",
            zIndex: "1",
          }}
        ></div>

        <h1>{com.name}</h1>

        {/* Long Version */}
        <p>{com.description}</p>
        {userLevel == 2 && user.communitySlug == com.slug ? (
          <Link
            to="/CreateProposal"
            className="btn btn-outline-dark btn-success "
          >
            Create New Proposal
          </Link>
        ) : null}

        <ProposalListing data={proposals} />
      </div>
    );
  }

  return <>{content}</>;
}
